export const ALT_KEY = {
    MAP: 'Map',
    COPY: "Copy",
    WARNING: "Warning",
    CLOSE: "Close",
    SUCCESS: "Success icon",
    LOADER: "Loader",
    NO_RECORD_FOUND: 'No reord found',
    TIP: 'Tip',
    LEAD_STATUS: "Lead status",
    STAR: "Star icn",
    CONGRATULATION: "Congratulation",
    AIRTEL_ICN: "Airtel icn",
    DOWNLOAD_ICN: "Download icn",
    PLANS_IMAGE: "Plans image",
    DESCRIPTION: "Description",
    INFOICN: "info icn"
}

export const WHATS_APP_IMAGE = "whatsapp.svg"
export const CALL_BACK_IMAGE = 'call.svg'
export const CLOSE_ICN = 'close.svg'
export const WHITE_START_ICN = 'whiteStar.svg'
export const SHOP_ICN = 'shopIcn.svg'
export const MAP_ICN = "map.svg"
export const COPY_ICN = "copy.svg"
export const NO_RECORD_FOUND_ICN = "noRecordFound.svg"
export const RETRY_ICN = "retry.svg"
export const DOWNLOAD_WHITE_ICN = "downloadWhiteIcn.svg"
export const BACK_BLACK_ICN = "backIcnBlack.svg"
export const CALL_BACK_WHITE_IMAGE = "callWhiteIcn.svg"
export const WHATS_APP_WHITE_IMAGE = "whatsappWhiteIcn.svg"
export const WARNING_IMAGE = "warningIcn.svg"
export const FORWARD_ICN_WHITE = "whiteRightIcn.svg"
export const HELP_WIDGETS_ICN = "helpWidgetsIcn.svg"
export const WHATSAPP_GREEN_ICN = "greenWhatsappIcn.svg"
export const DROP_DOWN_RED_ICN = "dropdownRedIcn.svg"
export const PENDING_ICN = "pending.svg"
export const CHECKMARK_RED_ICN = 'checkmark-red.svg'
export const COMPLETED_ICN = 'completed.svg'
export const INPROGRESS_ICN = 'in_progress.svg'
export const HOME_PAGE_BANNER_ICN = "fttxHomePageBanner.png"
export const WARNING_ICN = "warning.svg"
export const WARNING_BLUE_ICN = 'warningBlue.svg'
export const SIGNAL_GIF = 'signal.svg'
export const DOWNLOAD_ICN = "download.svg"
export const AIRTEL_ICN = "airtel_icn.svg"
export const CONGRATULATIONS_ICN = "congratulation.png"
export const TIP_ICN = 'tip.png'
export const INFOICN = "infoIcn.svg"
export const CRYSTAL_BG_IMAGE = "checkCoverageBg.svg"
export const MARKER = "marker.png";
export const SMALL_RED_PIN = "small-red-pin.png";
export const LARGE_RED_PIN = "large-red-pin.png";
export const NOT_FOUND_IMAGE = "illustration-search-files.svg";
export const ADDRESS_LOADAR_IMG = "addressLoader.svg"
export const WARNING_ICON = "warning_icn.svg";
export const GREEN_TICK_IMG = "greenTick.svg"
export const DISCOUNT_IMG = "discount_icn.svg"
export const FTTX_PLANS_PAGE_MWEB_BANNER_IMG = "fttxPlansBannerMview.svg"
export const FTTX_PLANS_PAGE_BANNER_IMG = "fttxPlansBanner.svg"
export const SERVICE_UNAVAILABLE_IMG = "serviceUnavailable.svg"
export const RECIEPT_DOWNLOAD_ICN = "downloadIcnWithText.svg"
export const FAQ_ICN = "FaqIcn.svg"
export const INFO_RED_ICN = "InfoRedIcn.svg"
export const COUNTRY_RED_ICN = "CountryRedIcn.svg"
export const ROUTE_MAP_ICN = "RouteMapIcn.svg"
export const FLASH_RED_ICN = "FlashRedIcon.svg"
export const PHONE_BLUE_ICN = "PhoneBlueIcn.svg"
export const NETWORK_ICN = "NetworkIcon.svg"
export const WIFI_ICN = "WifiIcon.svg"
export const WARNING_WHITE_ICN = "warningWhiteIcn.svg"
export const IR_HEADER_ICN = "IRHeadrIcn.svg"
export const COUNTRY_FLAG_SPRITE_ICN = "countriesFlags.png"
export const DROP_DOWN_ICN = "dropIcon.svg"
export const SEARCH_ICN = "SearchIcn.svg"
export const RIGHT_ARROW_ICN = "RightArrowIcn.svg"
export const INSTALLATION_ICN = "installation.svg"
export const UP_ARROW_ICN = "UpArrowIcn.svg"
export const DOWN_ARROW_ICN = "DownArrowIcn.svg"
export const ERROR_WHITE_ICON="ErrorIcnWhite.svg"
export const FIBER_ROUTER_IMG = "fttx_broadband.png";
export const ADD_TASK_ICON = "add_task.svg";
export const INFO_ICON = "infoIcn.svg";
export const CIRCULAR_WARNING_ICON = "circular_warning_icn.svg";
export const FILLED_CIRCULAR_WARNING_ICON = "filled_circular_warning_icn.svg";
export const CLOSE_ICON = "close_icon.svg";
export const ACTIVE_PLAN_ICON = "active_icn.svg";
export const UPCOMING_PLAN_ICON = "upcoming_icn.svg";
export const CALENDAR_ICON = "calender_icn.svg";
export const COMING_SOON_ICON = "coming_soon_icn.svg";
export const SPEEDMETER_ICON = "speedmeter_icn.svg";
export const EXPIRY_WARNING_ICON_BLINK = "msisdn_warning_icn_blink.svg";
